import { useState } from 'react'

const FAQS = [
  {
    q: 'Is there really a free plan?',
    a: 'Yes — DoorChart has a genuinely useful free tier. Up to 5 members, shared calendar, tasks, shopping lists, meal planning, and notes. No credit card required. Free forever.',
  },
  {
    q: 'What does "household billing" mean?',
    a: 'One subscription covers your whole household. If you pay for Premium, every member you invite gets Premium features. You\'re not billed per person.',
  },
  {
    q: 'Does it work offline?',
    a: 'Yes. DoorChart is a Progressive Web App with a service worker that caches your data locally. You can view and add events, tasks, and lists even with no internet connection. Changes sync when you\'re back online.',
  },
  {
    q: 'What is "linked households"?',
    a: 'Linked households lets two separate households — like co-parents in different homes — share a read-only calendar view of each other\'s schedules. Each household keeps its own private data; only the shared calendar is visible to the other.',
  },
  {
    q: 'How secure is the Vault?',
    a: 'Vault entries are encrypted with AES-256 before being stored. Your plaintext data never leaves your device unencrypted. Even Supabase (our database provider) cannot read your vault contents.',
  },
  {
    q: 'Can I cancel my subscription?',
    a: 'Yes, anytime. Cancel from Settings → Billing — no hoops, no waiting on hold. You keep Premium access until the end of your current billing period.',
  },
  {
    q: 'What happens to my data if I cancel?',
    a: 'Your data stays in your account on the Free plan. You keep access to everything except Premium features. If you ever delete your account, your data is permanently deleted within 30 days.',
  },
  {
    q: 'Is there a mobile app?',
    a: 'DoorChart is a PWA (Progressive Web App) — install it from your browser on iOS or Android and it behaves exactly like a native app, including offline support and home screen icon. No app store required.',
  },
  {
    q: 'How many people can be in a household?',
    a: 'The free plan supports up to 5 members. Any paid plan (Monthly, Annual, or Lifetime) supports unlimited members.',
  },
  {
    q: 'Do you offer a family or group discount?',
    a: 'The household billing model is already our group discount — one flat rate covers everyone. If you need something specific for a large organisation, reach out at hello@doorchart.com.',
  },
]

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="border-b border-border last:border-0">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between py-5 text-left gap-4 min-h-0"
        aria-expanded={open}
      >
        <span className="font-medium text-text-primary text-sm sm:text-base">{q}</span>
        <span className={`flex-shrink-0 w-5 h-5 rounded-full bg-primary-light text-primary flex items-center justify-center text-xs font-bold transition-transform ${open ? 'rotate-45' : ''}`}>
          +
        </span>
      </button>
      {open && (
        <div className="pb-5 text-sm text-text-secondary leading-relaxed -mt-1">
          {a}
        </div>
      )}
    </div>
  )
}

export const FAQSection = () => (
  <section id="faq" className="py-24 px-4 bg-primary-light">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12 reveal">
        <p className="text-primary text-sm font-semibold uppercase tracking-wider mb-3">FAQ</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-text-primary mb-4">
          Questions & answers
        </h2>
        <p className="text-text-secondary">
          Everything you need to know before getting started.
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-border shadow-sm px-6 reveal">
        {FAQS.map(({ q, a }) => (
          <FAQItem key={q} q={q} a={a} />
        ))}
      </div>

      <p className="text-center text-sm text-text-secondary mt-8 reveal">
        Still have questions?{' '}
        <a href="mailto:hello@doorchart.com" className="text-primary font-semibold hover:underline">
          Email us →
        </a>
      </p>
    </div>
  </section>
)
